import React from "react";
import { connect } from "react-redux";
import SolicitudesGrid from "./solicitudes";
import LoadingOverlay from "../../../../Shared/LoadingOverlay";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";

class Confirmacion extends React.Component {
  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  shouldComponentUpdate = (nextProps) => {
    if (nextProps.isLoading !== this.props.isLoading) {
      return true;
    }

    return false;
  }

  render() {
    return (
      <div>
        {this.props.isLoading && <LoadingOverlay />}
        <SolicitudesGrid />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.confirmacionSolicitudesAgendaSel.isLoading,
  selectedTipoSolicitud: state.confirmacionSolicitudesAgendaSel.selectedTipoSolicitud,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Confirmacion);
